module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_beach-photo-d90201adff1cf7e7d8bf3038e3f5793a.jpg";